import styled from 'react-emotion'
import { color, space4 } from '../style'

const Card = styled('div')({
  borderRadius: 4,
  background: color.greyBlock,
  padding: space4,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  marginBottom: 20
})

export const CardHeader = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  fontSize: 16
})

export default Card
